window.onload = function () {
    const submitButton = document.querySelector('button.onst-custom-form-submit');
    // const bussinessNameInput = document.querySelector('#wRegisterForm-text-0');
    const contactNameInput = document.querySelector('#wRegisterForm-text-7');
    const phoneInput = document.querySelector('#wRegisterForm-tel-5');
    const emailInput = document.querySelector('#wRegisterForm-email-8');

    if (!submitButton || !contactNameInput || !phoneInput || !emailInput) return;

    let formSubmitted = false;

    function findWarningElement(inputElement) {
        return inputElement.closest('.onst-field')?.querySelector('.onst-warning');
    }

    function validateField(input, regex, warningText) {
        const value = input.value.trim();
        const warning = findWarningElement(input);
        const isValid = regex.test(value);

        if (!isValid && formSubmitted) {
            if (warning) {
                warning.textContent = warningText;
                warning.classList.add('show');
            }
        } else {
            if (warning) {
                warning.textContent = '';
                warning.classList.remove('show');
            }
        }

        return isValid;
    }

    function validateForm() {
        // const isValid1 = validateField(bussinessNameInput, /^[A-Za-z\s]+$/, 'Business name should only contain letters.');
        const isValid2 = validateField(contactNameInput, /^[A-Za-z\s]+$/, 'Contact name should only contain letters.');
        const isValid3 = validateField(phoneInput, /^\d+$/, 'Phone should only contain numbers.');
        const isValid4 = validateField(emailInput, /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address.');

        return isValid2 && isValid3 && isValid4;
    }

    // Handle submit click
    submitButton.addEventListener('click', function (e) {
        formSubmitted = true; // Now we start showing validation errors

        const isValid = validateForm();

        if (!isValid) {
            e.preventDefault();
            submitButton.disabled = true;
        } else {
            submitButton.disabled = false;
        }
    });

    // On input changes
    [contactNameInput, phoneInput, emailInput].forEach(input => {
        input.addEventListener('input', () => {
            if (!formSubmitted) return;

            const isValid = validateForm();
            submitButton.disabled = !isValid;
        });
    });
};
